export default "__VITE_ASSET__BWUDn5CY__"